import { forwardRef } from 'react';

import { Card } from '@growtherapy/sprout-ui';

import {
  MeasureInsightTableConnected,
  type MeasureInsightTableConnectedProps,
} from '@grow-therapy-team/seedling-components';

import { PROGRESS_TITLE } from './constants';

export const ClientInformationProgress = forwardRef<HTMLDivElement, MeasureInsightTableConnectedProps>(
  (measureInsightTableProps, ref) => {
    return (
      <div
        className='flex flex-col gap-2'
        ref={ref}
        // tabIndex={-1} allows the div to be programmatically focused when
        // navigating from pre-visit summary resource buttons, but excludes it
        // from keyboard tab order
        tabIndex={-1}
        aria-labelledby='measures-progress-title'
      >
        <Card
          title={PROGRESS_TITLE}
          titleAs='h3'
          id='measures-progress-title'
          // MeasureInsightTableConnected exposes no className, so the panel's <details> is targeted from here.
          className='rebrand:bg-surface-inverseEmphasis [&_details]:arc:px-0'
          titleClassName='rebrand:text-text-inverse'
        >
          <MeasureInsightTableConnected isInverse {...measureInsightTableProps} />
        </Card>
      </div>
    );
  },
);
ClientInformationProgress.displayName = 'ClientInformationProgress';
